export const GET_POS_MEAL_TYPES = 'GET_POS_MEAL_TYPES';
export const SELECT_POS_MEAL_TYPES = 'SELECT_POS_MEAL_TYPES';
export const SELECT_POS_MEAL_TYPES_SUBMENU = 'SELECT_POS_MEAL_TYPES_SUBMENU';
export const GET_POS_MEAL_TYPES_SUBMENU = 'GET_POS_MEAL_TYPES_SUBMENU';
export const GET_POS_MEAL_SELECTED_FOOD_ITEMS =
  'GET_POS_MEAL_SELECTED_FOOD_ITEMS';
export const SELECT_FOOD_ITEM = 'SELECT_FOOD_ITEM';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export const GET_SERVED_ITEMS_FETCHING = 'GET_SERVED_ITEMS_FETCHING';
export const GET_SERVED_ITEMS_FETCH = 'GET_SERVED_ITEMS_FETCH';
export const UPDATE_SERVED_ITEMS = 'UPDATE_SERVED_ITEMS';
export const TOGGLE_SERVED_ITEM_SELECTION = 'TOGGLE_SERVED_ITEM_SELECTION';
export const RESTORE_MENUS_FROM_USER_SETTINGS =
  'RESTORE_MENUS_FROM_USER_SETTINGS';
export const GET_SERVED_ITEMS_FETCH_ERROR = 'GET_SERVED_ITEMS_FETCH_ERROR';

export const SAVE_ORDER_NUM_FETCHING = 'SAVE_ORDER_NUM_FETCHING';
export const SAVE_ORDER_NUM_SUCCESS = 'SAVE_ORDER_NUM_SUCCESS';
export const SAVE_ORDER_NUM_ERROR = 'SAVE_ORDER_NUM_ERROR';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/state/types.js